import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ResidentialPg = () => {
    const steps = ['Propety Details', 'Room Details', 'Photos', 'Review & Submit'];
    const [activeStep, setActiveStep] = useState(0);
    const [error, setError] = useState("");

    const token = localStorage.getItem('authToken');

    // State to store form data for all steps
    const [formData, setFormData] = useState({
        propertyDetails: { type: 'residential', service: 'pg', address: '', locality: '', pg_name: '', total_bed: '', pg_is: '', best_suited: '', meal_available: '', meal_offers: '', notice_period: '', lock_period: '', common_area: '' },
        roomDetails: { room_type: '', monthlyRent: '', security_deposit: '' },
        photos: []
    });

    const [errors, setErrors] = useState({});

    const handleInputChange = (step, field, value) => {
        setFormData((prev) => ({
            ...prev,
            [step]: {
                ...prev[step],
                [field]: value,
            },
        }));
        setErrors((prev) => ({
            ...prev,
            [field]: '', // Clear error for the field being modified
        }));
    };

    const validateStep = () => {
        const newErrors = {};
        if (activeStep === 0) {
            if (!formData.propertyDetails.type) newErrors.type = "Property type is required.";
            if (!formData.propertyDetails.service) newErrors.service = "Service type is required.";
            if (!formData.propertyDetails.locality.trim()) newErrors.locality = "Locality is required.";
            if (!formData.propertyDetails.pg_name.trim()) newErrors.pg_name = "PG Name is required.";
            if (!formData.propertyDetails.total_bed.trim()) newErrors.total_bed = "Total Bed is required.";
            if (!formData.propertyDetails.pg_is) newErrors.pg_is = "PG is required.";
            if (!formData.propertyDetails.best_suited) newErrors.best_suited = "Best Suited is required.";
            if (!formData.propertyDetails.meal_available) newErrors.meal_available = "Meal Available is required.";
            if (['yes'].includes(formData.propertyDetails.meal_available)) {
                if (!formData.propertyDetails.meal_offers) newErrors.meal_offers = "Meal Offers is required.";
            }
            if (!formData.propertyDetails.notice_period.trim()) newErrors.notice_period = "Notice Period is required.";
            if (!formData.propertyDetails.lock_period.trim()) newErrors.lock_period = "Lock Period is required.";
            if (!formData.propertyDetails.common_area.trim()) newErrors.common_area = "Common Area is required.";
        }
        if (activeStep === 1) {
            if (!formData.roomDetails.room_type.trim()) newErrors.room_type = "Room Type is required.";
            if (!formData.roomDetails.monthlyRent.trim()) newErrors.monthlyRent = "Rent is required.";
            if (!formData.roomDetails.security_deposit.trim()) newErrors.security_deposit = "Security Deposit is required.";
        }
        if (activeStep === 2) {
            if (!formData.photos[0]) newErrors.files = "Please upload at least one image.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChangeFiles = (e) => {
        const { name, files } = e.target;
    
        if (name === 'image' && files.length > 0) {
          // Convert the FileList to an array
          const fileArray = Array.from(files);
      
         console.log(fileArray);
      
          setFormData((prev) => ({
            ...prev,
            photos: fileArray, // Replace the previous photos array with the new files
          }));
        }
        setErrors((prev) => ({
          ...prev,
          photos: '', // Clear error for photos
        }));
      
    };

    const handleNextStep = () => {
        if (validateStep()) {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleSubmit = async (e) => {
        //alert(JSON.stringify(formData));  
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/residentialRent`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`, // Attach Bearer token
                    'Content-Type': 'multipart/form-data', // Set correct content type for file upload
                  },
            });
            console.log('API Response:', response.data);
            alert("Property Add SuccessFully");
        } catch (error) {
            console.error("Property Add error:", error);
            setError("An error occurred. Please try again later.");
        }
    };

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Property Type</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'type', 'residential')}
                                >
                                    Residential
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'type', 'commercial')}
                                >
                                    Commercial
                                </button>
                            </div>
                            {errors.type && <small className="text-danger">{errors.type}</small>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Looking to</label>
                            <div className="btn-group" role="group">
                                <Link to="/residentialRent">
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'service', 'rent')}
                                    >
                                        Rent
                                    </button>
                                </Link>
                                <Link to="/residentialSell">
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'service', 'sell')}
                                    >
                                        Sell
                                    </button>
                                </Link>
                                <Link to="/residentialPg">
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.service === 'pg' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'service', 'pg')}
                                    >
                                        PG/Co-living
                                    </button>
                                </Link>
                            </div>
                            {errors.service && <small className="text-danger">{errors.service}</small>}
                        </div>


                        <div className="mb-3">
                            <label className="form-label">Address</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.address}
                                onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
                            />
                            {errors.address && <small className="text-danger">{errors.address}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Locality</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.locality}
                                onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                            />
                            {errors.locality && <small className="text-danger">{errors.locality}</small>}
                        </div>
                        <div className='md-3'>
                            <label className="form-label">PG Details</label>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">PG Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.pg_name}
                                onChange={(e) => handleInputChange('propertyDetails', 'pg_name', e.target.value)}
                            />
                            {errors.pg_name && <small className="text-danger">{errors.pg_name}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Total Beds</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.total_bed}
                                onChange={(e) => handleInputChange('propertyDetails', 'total_bed', e.target.value)}
                            />
                            {errors.total_bed && <small className="text-danger">{errors.total_bed}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">PG is for</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.pg_is === 'girl' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'pg_is', 'girl')}
                                >
                                    Girl
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.pg_is === 'boy' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'pg_is', 'boy')}
                                >
                                    Sell
                                </button>
                            </div>
                            {errors.pg_is && <small className="text-danger">{errors.pg_is}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Best suited for</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.best_suited === 'student' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'best_suited', 'student')}
                                >
                                    Student
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.best_suited === 'professional' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'best_suited', 'professional')}
                                >
                                    Professionals
                                </button>
                            </div>
                            {errors.best_suited && <small className="text-danger">{errors.best_suited}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Meal Available</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.meal_available === 'yes' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'meal_available', 'yes')}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.meal_available === 'no' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'meal_available', 'no')}
                                >
                                    No
                                </button>
                            </div>
                            {errors.meal_available && <small className="text-danger">{errors.meal_available}</small>}
                        </div>
                        {formData.propertyDetails.meal_available === 'yes' && (
                            <div className="mb-3">
                                <label className="form-label">Meal Offerings</label>
                                <div className="btn-group" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.meal_offer === 'breakfast' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'meal_offer', 'breakfast')}
                                    >
                                        Breakfast
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.meal_offer === 'lunch' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'meal_offer', 'lunch')}
                                    >
                                        Lunch
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${formData.propertyDetails.meal_offer === 'dinner' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('propertyDetails', 'meal_offer', 'dinner')}
                                    >
                                        Dinner
                                    </button>
                                </div>
                                {errors.meal_offer && <small className="text-danger">{errors.meal_offer}</small>}
                            </div>
                        )}
                        <div className="mb-3">
                            <label className="form-label">Notice Period</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.notice_period}
                                onChange={(e) => handleInputChange('propertyDetails', 'notice_period', e.target.value)}
                            />
                            {errors.notice_period && <small className="text-danger">{errors.notice_period}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Lock in Period</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.propertyDetails.lock_period}
                                onChange={(e) => handleInputChange('propertyDetails', 'lock_period', e.target.value)}
                            />
                            {errors.lock_period && <small className="text-danger">{errors.lock_period}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Common Areas</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.common_area === 'living_room' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'common_area', 'living_room')}
                                >
                                    Living Room
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.common_area === 'kitchen' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'common_area', 'kitchen')}
                                >
                                    Kitchen
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.common_area === 'dining_hall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'common_area', 'dining_hall')}
                                >
                                    Dining Hall
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.common_area === 'study_room' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'common_area', 'study_room')}
                                >
                                    Study Room / Library
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.propertyDetails.common_area === 'breakout_room' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('propertyDetails', 'common_area', 'breakout_room')}
                                >
                                    Breakout Room
                                </button>
                            </div>
                            {errors.common_area && <small className="text-danger">{errors.common_area}</small>}
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Room Type</label>
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`btn ${formData.roomDetails.room_type === 'private_room' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('roomDetails', 'room_type', 'private_room')}
                                >
                                    Private Room
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.roomDetails.room_type === 'double_sharing' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('roomDetails', 'room_type', 'double_sharing')}
                                >
                                    Double Sharing
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.roomDetails.room_type === 'triple_sharing' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('roomDetails', 'room_type', 'triple_sharing')}
                                >
                                    Triple Sharing
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.roomDetails.room_type === '3+sharing' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('roomDetails', 'room_type', '3+sharing')}
                                >
                                    3+ Sharing
                                </button>
                            </div>
                            {errors.room_type && <small className="text-danger">{errors.room_type}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Rent</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.roomDetails.monthlyRent}
                                onChange={(e) => handleInputChange('roomDetails', 'monthlyRent', e.target.value)}
                            />
                            {errors.monthlyRent && <small className="text-danger">{errors.monthlyRent}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Security Deposit</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.roomDetails.security_deposit}
                                onChange={(e) => handleInputChange('roomDetails', 'security_deposit', e.target.value)}
                            />
                            {errors.security_deposit && <small className="text-danger">{errors.security_deposit}</small>}
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Upload Photos</label>
                            <input
                                type="file"
                                name='image'
                                onChange={(e) => handleChangeFiles(e)}
                                className="form-control"
                                multiple
                            />
                            {errors.files && <small className="text-danger">{errors.files}</small>}
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Review</label>
                                <div>
                                    <p>Review all the entered details:</p>
                                    <pre>{JSON.stringify(formData, null, 2)}</pre>
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                );
            default:
                return <p>Select a step to continue.</p>;
        }
    };

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-4">
                    <div className="list-group">
                        {steps.map((step, index) => (
                            <button
                                key={index}
                                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                                onClick={() => setActiveStep(index)}
                            >
                                {step}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="col-md-8">
                    <div className="card">
                        <div className="card-header">{steps[activeStep]}</div>
                        <div className="card-body">{renderStepContent(activeStep)}</div>
                        <div className="card-footer text-end">
                            {activeStep > 0 && (
                                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                                    Previous
                                </button>
                            )}
                            {activeStep < steps.length - 1 ? (
                                <button className="btn btn-primary" onClick={handleNextStep}>
                                    Next
                                </button>
                            ) : (
                                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResidentialPg
